import {SERVICES} from '@/const';

const PREFIX_RECEIVE_V2 = `${SERVICES.IMG_URL}/v1/`;

export const IMAGES_V2 = {
  BANNER: '20b2e5d1/banner-2x.png',
  ADVANTAGE_1: 'f9650ee2-0eff-46f4-b70a-4048648d737a/ad-01.png',
  ADVANTAGE_2: '258e6e19-2525-416f-9c52-07dd92bd498a/ad-02.png',
  ADVANTAGE_3: '4dbb531e-04f1-4087-8f79-90dd158530ee/ad-03.png',
  ADVANTAGE_4: '501c87d1-b325-48a7-b963-babe01202978/ad-04.png',
  SOLUTION_1: '3501fd60/icon01-2x.png',
  SOLUTION_2: 'a55a8819/icon02-2x.png',
  SOLUTION_3: '61f4d04f/icon03-2x.png',
  SOLUTION_4: '78d59686/icon04-2x.png',
  SOLUTION_5: '12fb7f3d/icon05-2x.png',
  SOLUTION_6: '018ee28c/icon06-2x.png',
  PROGRAM_1: 'dc9cf768-54b3-4e16-aa3b-7e8beb507384/market01.png',
  PROGRAM_2: '8d3d354b-c574-43f5-b1df-7bf622d8f5ae/broker01.png',
  SHARE: 'b913cccf/vector.png',
  WAIT: '40fd3a31-3ba0-494c-a847-ff317b2c8333/processing.svg',
  BONUS_PROGRAM_1: '5223f972-d95f-4ee4-b3ec-c97503b33298/mask-group.svg',
  BONUS_PROGRAM_2: 'ee0a863a-1e22-4093-92ab-cf04ed7e3bf5/collaborator-program-2x.png',
};

Object.keys(IMAGES_V2).forEach((key) => (IMAGES_V2[key] = [PREFIX_RECEIVE_V2, IMAGES_V2[key]].join('')));
